<template>
    <div class="disclaimer-page">
        <page-header :title="title" :items="items" />

        <div v-if="!editMode || (editMode && disclaimer.id)" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <add-edit-form
                            v-model="disclaimer"
                            :edit-mode="editMode"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div :class="{ 'mb-3': editMode }">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            :edit-mode="editMode"
                            :sections="sections"
                            :item="disclaimer"
                            @on-delete-confirm="onDeleteConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { required } from 'vuelidate/lib/validators';
import AddEditForm from '@/components/disclaimers/AddEditForm';
import ItemInformation from '@/components/elements/ItemInformation';

export default {
    page: {
        title: 'Manage disclaimer'
    },

    validations: {
        disclaimer: {
            name: {
                required
            },
            content: {
                required
            }
        }
    },

    components: {
        AddEditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: id ? 'Edit disclaimer' : 'Add disclaimer',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Disclaimers',
                    to: '/disclaimers'
                },
                {
                    text: id ? 'Edit' : 'Add',
                    active: true
                }
            ],
            id,
            editMode: !!id,
            disclaimer: {
                content: '',
                isManualSign: false
            },
            serverErrors: []
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    async created() {
        if (this.editMode) {
            try {
                this.disclaimer = await this.getDisclaimer(this.id);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    },

    methods: {
        ...mapActions({
            addDisclaimer: 'disclaimers/store',
            deleteDisclaimer: 'disclaimers/destroy',
            getDisclaimer: 'disclaimers/show',
            updateDisclaimer: 'disclaimers/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                if (!this.editMode) {
                    const added = await this.addDisclaimer(this.disclaimer);

                    this.$router.push(`/disclaimers/${added.id}/edit`);
                } else {
                    const { updatedAt } = await this.updateDisclaimer({
                        id: this.id,
                        data: this.disclaimer
                    });

                    this.disclaimer.updatedAt = updatedAt;

                    this.$toaster('Disclaimer updated!');
                }
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }
                console.error(error);

                this.$toasterError();
            }
        },

        async onDeleteConfirm() {
            try {
                await this.deleteDisclaimer(this.id);

                this.$router.push('/disclaimers');
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.UNPROCESSABLE_ENTITY && data) {
                        this.$toasterError(data);

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
